import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import RequireAuth from "./screens/Components/RequireAuth";
import MainPage from "./screens/Pages/MainPage/MainPage";
import OtpVerification from "./screens/Pages/OtpVerification.jsx/OtpVerification";
import MainComponent from "./screens/Pages/MainComponent/MainComponen";
import ResetPassword from "./screens/Pages/ResetPassword/ResetPassword";
import PurchaseDetails from "./screens/Pages/PurchaseDetails/PurchaseDetails";
import Dashboard from "./screens/Pages/Dashboard/Dashboard/Dashboard";
import PoDetails from "./screens/Pages/PoDetails/PoDetails";
import ForgetPassword from "./screens/Pages/ForgetPassword";
import NotFound from "./screens/Components/NotFount";

function Router() {
  const token = localStorage.getItem("accessToken");
  return (
    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/Login" element={<MainPage />} />
      <Route path="/Registration" element={<MainComponent />}>
        <Route path="OtpVerification" element={<OtpVerification />} />
        <Route path="ChangePassword" element={<ResetPassword />} />
        <Route path="ForgetPassword" element={<ForgetPassword />} />
      </Route>
      <Route
        path="/Dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      >
        <Route path="PurchaseDetails" element={<PurchaseDetails />} />
        <Route path="PoDetails" element={<PoDetails />} />
      </Route>
      <Route path="/404" element={<NotFound />} />
      <Route path="*" element={<Navigate to="/404" replace />} />
      {!token && <Route path="/Login" element={<MainPage />} />}
    </Routes>
  );
}

export default Router;
